import { faDollarSign, faXmarkLarge } from '@fortawesome/duotone-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import { PriceLevel } from './PriceLevel';
import './PriceLevelSymbols.scss';

interface Props {
  readonly priceLevel: PriceLevel | null;
}

export const PriceLevelSymbols: FC<Props> = ({ priceLevel }) => {
  switch (priceLevel) {
    case null:
      return (
        <span className={'icon is-small'} title={'No pricing available'}>
          <span className={'fa-layers fa-fw'}>
            <FontAwesomeIcon icon={faDollarSign} swapOpacity size={'lg'} />
            <FontAwesomeIcon icon={faXmarkLarge} swapOpacity size={'lg'} />
          </span>
        </span>
      );
    case PriceLevel.Free:
      return (
        <span className={'icon is-small price-level'} title={'Free'}>
          <FontAwesomeIcon icon={faDollarSign} swapOpacity size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} swapOpacity size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} swapOpacity size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} swapOpacity size={'lg'} />
        </span>
      );
    case PriceLevel.Inexpensive:
      return (
        <span title={'Inexpensive'} className={'icon is-small price-level'}>
          <FontAwesomeIcon icon={faDollarSign} size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} swapOpacity size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} swapOpacity size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} swapOpacity size={'lg'} />
        </span>
      );
    case PriceLevel.Moderate:
      return (
        <span className={'icon is-small price-level'} title={'Moderate'}>
          <FontAwesomeIcon icon={faDollarSign} size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} swapOpacity size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} swapOpacity size={'lg'} />
        </span>
      );
    case PriceLevel.Expensive:
      return (
        <span className={'icon is-small price-level'} title={'Expensive'}>
          <FontAwesomeIcon icon={faDollarSign} size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} swapOpacity size={'lg'} />
        </span>
      );
    case PriceLevel.VeryExpensive:
      return (
        <span className={'icon is-small price-level'} title={'Very Expensive'}>
          <FontAwesomeIcon icon={faDollarSign} size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} size={'lg'} />
          <FontAwesomeIcon icon={faDollarSign} size={'lg'} />
        </span>
      );
  }
};
PriceLevelSymbols.displayName = 'PriceLevelSymbols';
